// extracted by mini-css-extract-plugin
module.exports = {"productList":"FeatureList-module--productList--2fDRd"};